import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { Section } from './Shared';
import { BodySilhouette } from './BioDecor';
const problems: {
  problem: string;
  consequence: string;
}[] = [{
  problem: 'I arrive without a clear protocol',
  consequence: 'I improvise questions without a structure to support me.'
}, {
  problem: 'I do not have an organised opening process',
  consequence: 'I lose the first important minutes of the session in uncertainty.'
}, {
  problem: 'I do not have closing practices ready',
  consequence: 'The session ends without a clear pathway for integration.'
}, {
  problem: 'I do not have clear documentation or boundaries',
  consequence: 'I work with less organisation and less clarity about my role.'
}, {
  problem: 'I do not know how to create continuity',
  consequence: 'Every session feels like starting from zero.'
}, {
  problem: 'I finish emotionally drained after some sessions',
  consequence: 'I do not have clear resources for practitioner self-care or professional closure.'
}, {
  problem: 'I struggle to communicate my value',
  consequence: 'I offer individual sessions, but not a structured professional process.'
}, {
  problem: 'Clients do not understand the depth of my work',
  consequence: 'I do not clearly show the value of a guided, organised session.'
}];
export function PainPoints() {
  return <Section className="max-w-5xl" data-id="element-284" data-mp="23trc26l5rmir">
      <div className="relative overflow-hidden rounded-3xl border border-blue-200 bg-blue-50 p-6 md:p-10" data-id="element-285" data-mp="1g1awq3st28n5">
        <BodySilhouette className="pointer-events-none absolute -right-4 -top-6 h-56 w-28 text-blue-900/15" data-id="element-286" data-mp="1b3hqxbvezgne" />
        <div className="relative" data-id="element-287" data-mp="1p3k6grg91xzh">
          <h2 className="mb-8 text-center text-2xl font-bold text-blue-900 md:text-4xl" data-id="element-288" data-mp="1p0een4g8ki02">
            ❌ WHAT HAPPENS WITHOUT A CLEAR SYSTEM
          </h2>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-289" data-mp="30gmjxdn1y7ff">
            {problems.map(item => <li key={item.problem} className="rounded-xl border-l-4 border-blue-700 bg-white p-5" data-id="element-290" data-mp="2vitckha0j7dk">
                <p className="flex items-start gap-2 text-sm font-bold text-blue-900 md:text-base" data-id="element-291" data-mp="1t5ohqucye1vq">
                  <HelpCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" data-id="element-292" data-mp="1y3qbqabx3llz" />
                  {item.problem}
                </p>
                <p className="mt-2 pl-6 text-sm leading-relaxed text-slate-700" data-id="element-293" data-mp="226cxbthzwaaq">→ {item.consequence}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}